// extracted by mini-css-extract-plugin
export default {"primeAlertDialogButton":"PrimeAlertDialog_primeAlertDialogButton__7w9E6","dialogButton":"PrimeAlertDialog_dialogButton__pOJM9"};